function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.73 11.02l-.079-.049-.136-.089-.132-.095-.064-.05-.277-.246-.06-.06L8 8.667l-.002.002L7.245 8l.002-.001-2.258-2.007a2.5 2.5 0 10.007 4.011l1.51-1.345.757.666-1.25 1.112a3.521 3.521 0 01-.258.24l-.148.118-.093.07L5.3 11l-.11.065-.166.085-.19.085-.166.064a3.5 3.5 0 11.65-6.29l.152.098.155.112c.136.103.263.217.382.339L8 7.33l.004-.003.75.67-.002.002.546.485 1.191 1.066.003-.004.511.454.083.062a2.5 2.5 0 10-.075-4.07L9.497 7.337l-.752-.669 1.242-1.104c.08-.082.164-.161.252-.235l.17-.137.195-.134.077-.048a3.5 3.5 0 11.649 6.29l-.165-.064-.106-.045-.182-.09-.147-.081z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgInfinity = function SvgInfinity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfinity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Infinity.e443ce11.svg";
export { ForwardRef as ReactComponent };